import * as React from "react";
import Svg, { Path, Rect } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={90} height={62} viewBox="0 0 60 41" fill="none" {...props}>
      <Path d="M46.633 17.82H13.366v19.406h33.267V17.82z" fill="#296FE8" />
      <Path
        d="M30 25.941H21.88c-.875 0-1.584.71-1.584 1.585v9.702H30V25.941z"
        fill="#E5C040"
      />
      <Path
        d="M30 25.941h8.119c.875 0 1.584.71 1.584 1.585v9.702H30V25.941z"
        fill="#F8CE46"
      />
      <Path
        d="M18.713 12.078h-4.554l-3.565 5.545h5.545l2.574-5.545z"
        fill="#DB3832"
      />
      <Path
        d="M23.861 12.078h-5.148l-2.574 5.545h5.544l2.178-5.545z"
        fill="#F9D550"
      />
      <Path
        d="M27.822 12.078h-3.96l-2.179 5.545h5.545l.594-5.545z"
        fill="#DB3832"
      />
      <Path
        d="M32.178 12.078h-4.356l-.595 5.545h5.545l-.594-5.545zM36.337 12.078h4.752l2.772 5.545h-5.544l-1.98-5.545z"
        fill="#F9D550"
      />
      <Path
        d="M32.178 12.078h4.159l1.98 5.545h-5.545l-.594-5.545zM41.089 12.078h4.95l3.367 5.545H43.86l-2.772-5.545z"
        fill="#DB3832"
      />
      <Path
        d="M27.227 31.584a.693.693 0 111.387 0v.594a.693.693 0 01-1.387 0v-.594zM31.386 31.584a.693.693 0 111.386 0v.594a.693.693 0 01-1.386 0v-.594z"
        fill="#6D6E71"
      />
      <Path
        d="M10.594 17.625v2.108c0 1.265 1.213 2.248 2.773 2.248 1.559 0 2.772-.983 2.772-2.248v-2.108h-5.545z"
        fill="#AD232A"
      />
      <Path
        d="M16.139 17.625v2.108c0 1.265 1.213 2.248 2.772 2.248 1.56 0 2.772-.983 2.772-2.248v-2.108H16.14z"
        fill="#E5C040"
      />
      <Path
        d="M21.683 17.625v2.108c0 1.265 1.213 2.248 2.772 2.248 1.56 0 2.773-.983 2.773-2.248v-2.108h-5.545z"
        fill="#AD232A"
      />
      <Path
        d="M27.227 17.625v2.108c0 1.265 1.213 2.248 2.773 2.248s2.772-.983 2.772-2.248v-2.108h-5.544z"
        fill="#E5C040"
      />
      <Path
        d="M32.773 17.625v2.108c0 1.265 1.212 2.248 2.772 2.248 1.56 0 2.772-.983 2.772-2.248v-2.108h-5.544z"
        fill="#AD232A"
      />
      <Path
        d="M38.317 17.625v2.108c0 1.265 1.213 2.248 2.772 2.248 1.56 0 2.772-.983 2.772-2.248v-2.108h-5.544z"
        fill="#E5C040"
      />
      <Path
        d="M43.861 17.625v2.108c0 1.265 1.213 2.248 2.773 2.248 1.559 0 2.772-.983 2.772-2.248v-2.108H43.86z"
        fill="#AD232A"
      />
      <Path
        d="M10 38.415c0-.657.532-1.188 1.188-1.188h37.624c.656 0 1.188.532 1.188 1.188v1.584H10v-1.584z"
        fill="#58595B"
      />
      <Path fill="#296FE8" d="M23.861 8.711h12.277v3.366H23.861z" />
      <Path
        d="M18.317 1.98A1.98 1.98 0 0120.297 0h19.406a1.98 1.98 0 011.98 1.98v5.743a1.98 1.98 0 01-1.98 1.98H20.297a1.98 1.98 0 01-1.98-1.98V1.98z"
        fill="#E40046"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 9a4 4 0 100-8 4 4 0 000 8zm1.863-5.495v2.128h-.956V3.515h-.002a.22.22 0 00-.061-.154.214.214 0 00-.304-.003.22.22 0 00-.065.153v.004h-.001v2.118h-.956V3.508h-.002a.22.22 0 00-.063-.154.214.214 0 00-.304 0 .22.22 0 00-.063.154h-.001v2.125h-.956V3.501c0-.22.061-.436.176-.623a1.16 1.16 0 011.697-.328 1.164 1.164 0 011.684.334c.114.185.175.399.177.617v.004zm-.001 2.544a1.826 1.826 0 01-.539 1.319 1.868 1.868 0 01-1.328.548 1.886 1.886 0 01-1.327-.548 1.844 1.844 0 01-.54-1.319h.956c0 .239.096.468.267.636a.916.916 0 001.288 0 .894.894 0 00.267-.636h.956z"
        fill="#fff"
      />
      <Rect
        y={40}
        width={60}
        height={1}
        rx={0.5}
        fill="#000"
        fillOpacity={0.1}
      />
    </Svg>
  );
}

export default SvgComponent;
